import { FormGroup, fieldSubscription, useField, useIsDisabled } from '@ff-it/form';
import { Button, Dialog, DialogTrigger } from '@ff-it/ui';

import { ReactElement, ReactNode, useId } from 'react';
import { ListCampaign } from 'modules/campaign/campaign/types';
import { CampaignSelectDialog } from './CampaignSelectDialog';
import { CampaignChipTray } from './CampaignChipTray';
import { FilterType } from 'components/ControlledTable/types';

type SourceCampaignsFieldProps = {
  name: string;
  label?: ReactNode;
  id?: string;
  className?: string;
  disabled?: boolean;
  // special
  fixedIds?: number[];
  defaultFilter?: FilterType;
};

export function SourceCampaignsField({
  name,
  label,
  id: propId,
  className,
  disabled: propDisabled,
  fixedIds,
  defaultFilter,
}: SourceCampaignsFieldProps): ReactElement {
  const _id = useId();
  const id = propId || _id;

  const disabled = useIsDisabled(propDisabled);

  const {
    input: { value, onChange },
    meta,
  } = useField<ListCampaign[]>(name, { subscription: fieldSubscription });

  return (
    <FormGroup label={label} className={className} meta={meta} id={!disabled ? id : undefined}>
      <CampaignChipTray
        role="combobox"
        values={value}
        fixedIds={fixedIds}
        onRemove={(id) => onChange(value.filter((c) => c.id !== id))}
        disabled={disabled}
      >
        {!disabled && (
          <Dialog>
            <DialogTrigger>
              <Button id={id} icon="plus" variant="secondary" testId="select-source-campaigns" />
            </DialogTrigger>
            <CampaignSelectDialog value={value} fixedIds={fixedIds} defaultFilter={defaultFilter} onChange={onChange} />
          </Dialog>
        )}
      </CampaignChipTray>
      <input name={name} type="hidden" value={value.map((c) => c.id).join(',')} />
    </FormGroup>
  );
}
